import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que dejarlo llorar?',
  answer: 'No. El método se basa en el acompañamiento y la seguridad sensorial.'
}, {
  question: '¿Funciona si hacemos colecho?',
  answer: 'Sí, el protocolo de relajación funciona igual si duerme en su cuna o a tu lado.'
}, {
  question: '¿Cuánto tardaré en ver resultados?',
  answer: 'La mayoría de las mamás reportan una mejora drástica en los primeros 3 días.'
}, {
  question: '¿Es seguro?',
  answer: 'Totalmente, seguimos todas las pautas de sueño seguro de la Academia de Pediatría.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-gradient-to-b from-[#0f172a] to-[#1e293b] py-16 md:py-24" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-14">
          <div className="flex items-center justify-center gap-3 mb-12" data-id="element-15">
            <HelpCircleIcon className="w-8 h-8 text-[#d4a853]" data-id="element-16" />
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center" data-id="element-17">
              Preguntas <span className="text-[#d4a853]" data-id="element-18">Frecuentes</span>
            </h2>
          </div>

          <div className="space-y-4" data-id="element-19">
            {faqs.map((faq, index) => <motion.div key={index} className="bg-[#1e293b]/60 border border-[#334155] rounded-xl overflow-hidden" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-20">
                <button className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:ring-2 focus:ring-[#d4a853]/50 focus:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-21">
                  <span className="font-['DM_Sans'] font-semibold text-white text-lg pr-4" data-id="element-22">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-23">
                    <ChevronDownIcon className="w-6 h-6 text-[#d4a853] flex-shrink-0" data-id="element-24" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-25">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-26">
                      <div className="px-6 pb-6" data-id="element-27">
                        <p className="font-['DM_Sans'] text-gray-400 text-base leading-relaxed" data-id="element-28">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}